<script>
  export default {
    name: 'mvtMapResults',
    props: {
      current: {
        type: Number,
        required: true
      },
      total: {
        type: Number,
        required: true
      },
    },
    computed: {
      text() {
        if(!this.current){
          return this.molang('search.filter.map_result_marker_zero');
        }
        return this.molang('search.filter.map_result_marker_cnt_total', {
          pluralCount: this.current,
          TOTALLISTINGCOUNT: Math.max(this.total, this.current),
        });
      }
    },
  }
</script>

<template>
  <div class="mvt-map-results">
    {{ text }}
  </div>
</template>

<style lang="scss">
@use "~@/common/scss/base/_defined.scss" as *;

.mvt-map-results {
  text-align: center;
  padding:var(--gxs) var(--g2);
  color: var(--color-f);
  margin: 0px auto;
  background-color: rgba(71,78,82,0.7);
  @include f7();
  @include singleline();
  border-radius: 1rem;
  width: auto;
  @media screen and (max-width: $screen-xs-max) {
    margin-bottom:var(--form-size-3);
  }
}
</style>